import React from 'react'

import {
    Formik, Form
} from 'formik';
import * as Yup from 'yup';

import Modal from '../Modal'
import Button from '../Button'
import * as S from './styles'
import { DarkBlue, DarkBlueHover, Red, DarkRedHover } from '../../assets/colors'
import FormField from '../Form/FormField';

function ModalRemoveBatch({ deleteObject, deleteAction, cancelAction }) {
    const title = `Deseja realmente remover esse lote do recebimento ?`

    const closeModal = () => {
        cancelAction()
    }

    return (
        <Modal
            show={deleteObject !== undefined}
            closedButton={false}
            title={title}
            body={
                <Formik
                    initialValues={{
                        badgeUser: undefined
                    }}
                    validationSchema={
                        Yup.object().shape({
                            badgeUser: Yup.string()
                                .required('form.required')
                        })
                    }
                    onSubmit={(values, { setSubmitting, setFieldError }) => {
                        deleteAction(values.badgeUser).then(() => {
                            closeModal()
                        })
                        .catch((error) => {
                            if(error?.response) {
                                const { message } = error?.response.data
                                
                                setFieldError("badgeUser", message)
                            }
                            else {
                                console.error(error)
                                setFieldError("badgeUser", "Não foi possivel remover o lote do recebimento")
                            }
                        })
                        .finally(() => {
                            setSubmitting(false)
                        })
                    }}
                >
                    {({ isSubmitting, handleSubmit }) => (
                        <Form style={{padding: "0 20px 20px 20px"}}>
                            <S.ModalBody>
                                <S.ModalBody>
                                    <FormField
                                        label="badge.inspector"
                                        name="badgeUser"
                                        fieldType="password"
                                    />
                                </S.ModalBody>
                                <S.UL>
                                    {
                                        (deleteObject?.lot || deleteObject?.pendencyId) &&  
                                        <S.LI>
                                            <S.ListItem 
                                                label="Lote ID: " 
                                                description={deleteObject?.lot ? deleteObject?.lot : deleteObject?.pendencyId} 
                                            />
                                        </S.LI>
                                    }
                                    <S.LI>
                                        <S.ListItem
                                            label="Código de Barras: "
                                            description={deleteObject?.barcode}
                                        />
                                    </S.LI>
                                    <S.LI>
                                        <S.ListItem
                                            label="Descrição: "
                                            description={deleteObject?.description}
                                        />
                                    </S.LI>
                                    <S.LI>
                                        <S.ListItem
                                            label="Validade: "
                                            description={deleteObject?.expirationDate}
                                        />
                                    </S.LI>
                                </S.UL>
                            </S.ModalBody>
                            <S.ModalFooter>
                                <Button
                                    text="Excluir"
                                    style={{ marginRight: '5px', height: '45px', width: '150px', padding: 0, margin: 0 }}
                                    onClick={handleSubmit}
                                    color={Red}
                                    hoverColor={DarkRedHover}
                                    isDisabled={isSubmitting}
                                />

                                <Button
                                    text="Cancelar"
                                    onClick={closeModal}
                                    style={{ marginRight: '5px', height: '45px', width: '150px', padding: 0, margin: 0 }}
                                    color={DarkBlue}
                                    hoverColor={DarkBlueHover}
                                    isDisabled={isSubmitting}
                                />
                            </S.ModalFooter>
                        </Form>
                    )}
                </Formik>
            }
        />
    )
}

export default ModalRemoveBatch
